const validateField = (
  field: 'name' | 'relationship' | 'email',
  value: string,
  type?: string
): string => {
  if (field === 'name' && value.trim() === '')
    return 'Please enter their full name';
  if (field === 'relationship' && value.trim() === '')
    return 'Please enter their relationship';
  if (field === 'email') {
    if (value.trim() === '' && type === 'email')
      return 'Please enter their email!';
    if (value.trim() && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value))
      return "Please enter a valid recipient's email!";
  }
  return '';
};

export enum SharingACPTypes {
  EMAIL = 'email',
  PRINT = 'print',
}

export { validateField };
